(() => {
  'use strict';
  if (window.MMDiscovery) return;
  const key = 'mm_gender_pref';
  const valid = value => ['femme', 'homme', 'tout'].includes(value);
  const configNode = document.getElementById('mm-discovery-config');
  const config = configNode ? JSON.parse(configNode.textContent) : {};
  const messages = config.messages || {};
  let gender = 'tout';
  try { const saved = localStorage.getItem(key); if (valid(saved)) gender = saved; } catch {}
  const pathGender = location.pathname.match(/\/collections\/(?:[^/]*-)?(femme|homme)(?:-|\/|$)/);
  if (pathGender) gender = pathGender[1];
  let scanFrame = 0;
  let addQueue = Promise.resolve();
  const matches = (audience, preference) => {
    const normalized = String(audience || 'unknown').trim().toLowerCase();
    return preference === 'tout' || normalized === preference || normalized === 'unisex';
  };
  const text = (name, fallback) => messages[name] || fallback;

  function scan() {
    document.querySelectorAll('[data-mm-card]').forEach(card => {
      const grid = card.parentElement;
      if (grid?.tagName === 'UL' && !grid.hasAttribute('data-mm-card-grid')) {
        grid.setAttribute('data-mm-card-grid', '');
        grid.closest('.shopify-section')?.setAttribute('data-mm-grid-host', '');
      }
    });
    document.querySelectorAll('[data-mm-gender]').forEach(item => {
      if (item.closest('#MainContent')) item.hidden = !matches(item.dataset.mmGender, gender);
    });
    const sections = new Set();
    document.querySelectorAll('[data-mm-product-item]').forEach(item => {
      const section = item.closest('.shopify-section');
      if (section) sections.add(section);
    });
    sections.forEach(section => {
      section.dataset.mmSectionScope = '';
      const items = [...section.querySelectorAll('[data-mm-product-item]')];
      section.hidden = !items.some(item => !item.hidden);
    });
    document.querySelectorAll('[data-mm-filter-list]').forEach(list => {
      const filtered = [...list.querySelectorAll('[data-mm-product-item]')].some(item => item.hidden);
      const changed = list.hasAttribute('data-mm-filtered') !== filtered;
      list.toggleAttribute('data-mm-filtered', filtered);
      const swiper = list.parentElement?.swiper;
      if (swiper && !swiper.destroyed) {
        if (filtered && swiper.enabled) swiper.disable();
        else if (!filtered && changed) { swiper.enable(); swiper.update(); }
      }
    });
    document.querySelectorAll('[data-mm-card-grid]').forEach(grid => {
      let empty = grid.nextElementSibling;
      if (!empty?.hasAttribute('data-mm-empty')) {
        empty = document.createElement('p');
        empty.className = 'mm-gender-empty';
        empty.dataset.mmEmpty = '';
        empty.setAttribute('role', 'status');
        empty.append(document.createTextNode(text('empty', 'Aucun article dans cette sélection. ') + ' '));
        const reset = document.createElement('button');
        reset.type = 'button';
        reset.dataset.mmGenderChoice = 'tout';
        reset.textContent = text('show_all', 'Tout afficher');
        empty.append(reset);
        grid.after(empty);
      }
      empty.hidden = [...grid.querySelectorAll('[data-mm-card]')].some(card => !card.hidden);
    });
    document.querySelectorAll('mm-gender-switcher').forEach(switcher => {
      switcher.hidden = false;
      switcher.querySelectorAll('[data-mm-gender-choice]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.mmGenderChoice === gender));
      });
      const status = switcher.querySelector('[role="status"]');
      if (status) {
        const current = switcher.querySelector('[aria-pressed="true"]');
        const next = (current?.textContent || '') + ' · ' + text('updated', 'Sélection mise à jour');
        if (status.textContent !== next) status.textContent = next;
      }
    });
    document.querySelectorAll('[data-mm-context-link]').forEach(link => {
      const suffix = gender.charAt(0).toUpperCase() + gender.slice(1);
      const destination = link.dataset['href' + suffix];
      if (destination) link.href = destination;
      const label = link.dataset['label' + suffix];
      if (label && link.textContent !== label) link.textContent = label;
    });
    document.querySelectorAll('[data-mm-offer-end]').forEach(badge => {
      badge.hidden = Date.now() >= Number(badge.dataset.mmOfferEnd) * 1000;
    });
  }

  function scheduleOfferExpiry() {
    const now = Date.now();
    let next = Infinity;
    document.querySelectorAll('[data-mm-offer-end]').forEach(badge => {
      const remaining = Number(badge.dataset.mmOfferEnd) * 1000 - now;
      if (remaining <= 0) badge.hidden = true;
      else next = Math.min(next, remaining);
    });
    if (Number.isFinite(next)) setTimeout(scheduleOfferExpiry, Math.min(next + 1, 86400000));
  }

  function scheduleScan() {
    if (scanFrame) return;
    scanFrame = requestAnimationFrame(() => { scanFrame = 0; scan(); });
  }

  function setGender(value, persist = true) {
    if (!valid(value)) return;
    gender = value;
    if (persist) { try { localStorage.setItem(key, value); } catch {} }
    scan();
    window.dispatchEvent(new CustomEvent('mm:genderChange', { detail: { gender: value } }));
  }

  class GenderSwitcher extends HTMLElement { connectedCallback() { scheduleScan(); } }
  if (!customElements.get('mm-gender-switcher')) customElements.define('mm-gender-switcher', GenderSwitcher);
  document.addEventListener('click', event => {
    const choice = event.target.closest('[data-mm-gender-choice]');
    if (choice) setGender(choice.dataset.mmGenderChoice);
  });
  window.addEventListener('storage', event => {
    if (event.key === key) setGender(valid(event.newValue) ? event.newValue : 'tout', false);
  });
  document.addEventListener('shopify:section:load', scheduleScan);
  window.addEventListener('load', scheduleScan, { once: true });
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('[data-mm-gender], mm-gender-switcher') || node.querySelector('[data-mm-gender], mm-gender-switcher'))))) scheduleScan();
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });

  function showMessage(card, message, cartLink = false) {
    const target = card.querySelector('.mm-card__message');
    target.replaceChildren(document.createTextNode(message));
    if (cartLink) {
      const link = document.createElement('a');
      link.href = (window.Shopify?.routes?.root || '/') + 'cart';
      link.textContent = ' ' + text('open_cart', 'Ouvrir le panier');
      target.append(link);
    }
  }

  async function addVariant(form, button) {
    const card = form.closest('[data-mm-card]');
    const root = window.Shopify?.routes?.root || '/';
    const cart = document.querySelector('cart-sidebar');
    const sectionIds = cart?.getSectionsToRender?.().map(section => section.id) || [];
    const payload = { items: [{ id: button.value, quantity: 1 }] };
    if (sectionIds.length) {
      payload.sections = sectionIds;
      payload.sections_url = location.pathname;
    }
    let response;
    let result;
    try {
      response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', signal: AbortSignal.timeout(20000),
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      result = await response.json();
    } catch {
      showMessage(card, text('unconfirmed', 'Ajout non confirmé. Vérifiez votre panier avant de réessayer.'), true);
      return;
    }
    if (!response.ok || result.status) {
      const description = typeof result.description === 'string' ? result.description : text('error', 'Cet article ne peut pas être ajouté.');
      showMessage(card, description);
      if (response.status === 422) button.dataset.mmUnavailable = 'true';
      return;
    }
    showMessage(card, text('added', 'Ajouté au panier.'), true);
    const focusTarget = card.querySelector('summary') || button;
    card.querySelector('details')?.removeAttribute('open');
    window.dispatchEvent(new CustomEvent('mm:cartAdded', { detail: { variantId: button.value } }));
    if (!cart) return;
    try {
      cart.setActiveElement?.(focusTarget);
      const complete = sectionIds.length && sectionIds.every(id =>
        typeof result.sections?.[id] === 'string' &&
        new DOMParser().parseFromString(result.sections[id], 'text/html').querySelector('.shopify-section'));
      if (complete) cart.renderContents(result);
      else {
        await cart.reload();
        cart.revealStickyHeaderAndOpen?.(focusTarget) || cart.open?.(focusTarget);
      }
    } catch {
      showMessage(card, text('added', 'Ajouté au panier.'), true);
    }
  }

  document.addEventListener('submit', event => {
    const form = event.target.closest('.mm-card__form');
    if (!form) return;
    const button = event.submitter;
    if (!button?.matches('[data-mm-variant]')) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true' || button.dataset.mmUnavailable) return;
    form.setAttribute('aria-busy', 'true');
    const buttons = [...form.querySelectorAll('button')];
    buttons.forEach(item => { item.disabled = true; });
    showMessage(form.closest('[data-mm-card]'), text('adding', 'Ajout en cours…'));
    addQueue = addQueue.then(() => addVariant(form, button)).catch(() => {
      showMessage(form.closest('[data-mm-card]'), text('unconfirmed', 'Ajout non confirmé.'), true);
    }).finally(() => {
      form.removeAttribute('aria-busy');
      buttons.forEach(item => { item.disabled = item.dataset.mmUnavailable === 'true'; });
    });
  });

  document.addEventListener('pointerover', event => {
    const media = event.target.closest('.mm-card__media');
    if (!media || media.contains(event.relatedTarget) || !matchMedia('(hover: hover)').matches) return;
    const details = media.querySelector('details');
    if (details) details.open = true;
  });
  document.addEventListener('pointerout', event => {
    const media = event.target.closest('.mm-card__media');
    if (!media || media.contains(event.relatedTarget) || media.contains(document.activeElement)) return;
    if (matchMedia('(hover: hover)').matches) media.querySelector('details')?.removeAttribute('open');
  });
  window.MMDiscovery = { setGender, getGender: () => gender, matches, scan };
  setGender(gender, Boolean(pathGender));
  scheduleOfferExpiry();
})();
